import { gql, TypedDocumentNode } from "@apollo/client";

import { SharedModuleData } from "./types";

export type GetSharedModulesData = {
  sharedModulesV2: SharedModuleData[];
};

export const GET_SHARED_MODULES_V2: TypedDocumentNode<GetSharedModulesData> = gql`
  query GetSharedModulesV2 {
    sharedModulesV2 {
      id
      from {
        account {
          subdomain
        }
        space {
          id
          name
        }
      }
      to {
        account {
          subdomain
        }
        space {
          id
          name
        }
      }
      module {
        id
        description
        name
        latest {
          id
        }
        current {
          id
          number
          state
          yanked
        }
      }
    }
  }
`;
